export const POPUP_DATA_LOGS_ENDPOINT = '/clientteling/Get-Appointment-Activity-Logs';
